import styled from "styled-components";
import PageHeader from "../../features/shared/PageHeader";

const ListItem = styled.li`
  display: list-item;
  list-style-type: disc;
  margin-left: 24px;
  &::marker {
    color: #1b6dc1;
  }
`;

const CircleItem = styled.li`
  display: list-item;
  list-style-type: circle;
  margin-left: 40px;
  &::marker {
    color: #1b6dc1;
  }
`;

export default function GoverningLaw() {
  const sections = [
    { id: "local-authority", title: "Contact Local Authority" },
    { id: "governing-law", title: "Governing Law and Jurisdiction" },
    { id: "compliance-statement", title: "Additional Local & International Compliance" },
    { id: "applicable-laws", title: "1. Applicable Laws" },
    { id: "michigan-law", title: "2. Michigan Law" },
    { id: "local-international", title: "3. Local or International Use" },
    { id: "jurisdiction-venue", title: "4. Jurisdiction and Venue" },
    { id: "dispute-resolution", title: "5. Dispute Resolution" },
    { id: "severability", title: "6. Severability" },
    { id: "language", title: "7. Language" },
    { id: "food-regulations", title: "8. Compliance With Local Food Regulations" },
    { id: "disclaimer", title: "Platform Disclaimer & Food Compliance Policy" },
    { id: "contact", title: "Contact Information" },
  ];

  return (
    <div className="container page-navbar-space">
      <PageHeader>Governing Law</PageHeader>
      <div className="row mt-5">
        {/* LEFT SIDE: MAIN CONTENT */}
        <div
          className="col-lg-8 col-xl-9"
          style={{ color: "#444", lineHeight: "1.7" }}
        >
          <section
            id="local-authority"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">OwnFood Privacy Policy – Governing Law Clause</h4>
            <p className="size-16 fw-normal">
              Contact your local authority to find out the local laws before you sell any specific food item.
            </p>
          </section>

          <section
            id="governing-law"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">Governing Law and Jurisdiction</h4>
            <p className="size-16 fw-normal">
              This Privacy Policy and the use of the OwnFood platform, including the OwnFood mobile
              applications for Android and iOS, website, services, marketplace features, and all related
              activities, shall be governed by and interpreted in accordance with the laws of the State of
              Michigan, United States of America, without regard to conflict of law principles, except where
              mandatory local laws of another jurisdiction apply.
            </p>
            <p className="size-16 fw-normal">
              OwnFood operates as an online platform that allows users, home-based food sellers, cooks,
              buyers, delivery partners, and visitors to connect for the listing, promotion, sale, purchase, and
              delivery of homemade food products and related services in multiple countries and jurisdictions.
            </p>
            <p className="size-16 fw-normal">By accessing or using OwnFood, users acknowledge and agree that:</p>
            <ul className="ps-2 size-16 fw-normal">
              <ListItem>
                OwnFood may operate internationally and may provide services in multiple countries,
                states, provinces, and territories.
              </ListItem>
              <ListItem>
                Users are responsible for complying with all local laws, food safety regulations, cottage
                food laws, health department requirements, licensing rules, tax obligations, import/export
                restrictions, labeling laws, and consumer protection regulations applicable in their own
                jurisdiction.
              </ListItem>
              <ListItem>
                If OwnFood operates or provides services in a country or region outside the United
                States, the platform may also be subject to mandatory local privacy, consumer, and
                electronic commerce laws applicable in that jurisdiction.
              </ListItem>
              <ListItem>
                Nothing in this Privacy Policy shall limit any consumer rights or legal protections that
                cannot be waived under applicable local law.
              </ListItem>
              <ListItem>
                In the event of any dispute, claim, or controversy relating to privacy, data protection,
                platform use, transactions, or services provided through OwnFood, the parties agree that
                such matters shall be subject to the exclusive jurisdiction of the state or federal courts
                located in the State of Michigan, USA, unless applicable law in another jurisdiction
                requires otherwise.
              </ListItem>
              <ListItem>
                Where required by local law, OwnFood may comply with additional country-specific
                privacy regulations, including but not limited to:
                <ul className="ps-2 mt-1">
                  <CircleItem>General Data Protection Regulation (GDPR) for users in the European Economic Area (EEA)</CircleItem>
                  <CircleItem>UK GDPR and United Kingdom data protection laws</CircleItem>
                  <CircleItem>California Consumer Privacy Act (CCPA/CPRA)</CircleItem>
                  <CircleItem>Canadian privacy regulations</CircleItem>
                  <CircleItem>Australian Privacy Principles (APP)</CircleItem>
                  <CircleItem>Any other applicable national, state, or regional privacy laws in countries where OwnFood operates.</CircleItem>
                </ul>
              </ListItem>
              <ListItem>
                Users located outside the United States understand and agree that their information may
                be transferred to, stored, and processed in the United States or other countries where
                OwnFood, its affiliates, service providers, or technology partners operate.
              </ListItem>
            </ul>
            <p className="size-16 fw-normal mt-3">
              OwnFood reserves the right to modify, update, or amend this Privacy Policy and Governing Law
              section at any time in order to comply with operational, legal, regulatory, or international
              requirements. Continued use of the platform after such updates constitutes acceptance of the
              revised terms.
            </p>
          </section>

          <section
            id="compliance-statement"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">Additional Local &amp; International Compliance Statement</h4>
            <p className="size-16 fw-normal">
              OwnFood is intended to function as a global homemade food marketplace platform. Because
              laws related to homemade food sales, food preparation, online marketplaces, delivery services,
              taxation, and consumer protection vary by country and region, OwnFood does not guarantee
              that every product, listing, or seller activity is legally permitted in every jurisdiction.
            </p>
            <p className="size-16 fw-normal">Users, sellers, and buyers agree that:</p>
            <ul className="ps-2 size-16 fw-normal">
              <ListItem>
                Sellers are solely responsible for ensuring that their homemade food products comply
                with all applicable food preparation, packaging, labeling, licensing, health inspection,
                allergen disclosure, and local business laws.
              </ListItem>
              <ListItem>
                Buyers are responsible for reviewing product descriptions, ingredient disclosures, allergy
                information, and local restrictions before purchasing food items.
              </ListItem>
              <ListItem>
                OwnFood acts primarily as a technology platform connecting independent users and
                does not independently manufacture, prepare, inspect, certify, or guarantee food
                products listed by third-party sellers unless explicitly stated otherwise.
              </ListItem>
              <ListItem>
                Each user assumes responsibility for lawful use of the platform within their country, state,
                province, or local jurisdiction.
              </ListItem>
            </ul>
            <p className="size-16 fw-normal mt-3">
              By accessing or using OwnFood, users, sellers, buyers, vendors, cooks, delivery partners,
              advertisers, and all other participants agree to the following terms:
            </p>
          </section>

          <section
            id="applicable-laws"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">1. Applicable Laws</h4>
            <p className="size-16 fw-normal">
              OwnFood operates internationally and complies, to the extent reasonably applicable, with the
              laws and regulations of the countries, states, provinces, territories, and local jurisdictions where
              its services are offered or accessed.
            </p>
            <p className="size-16 fw-normal">
              Users are solely responsible for ensuring that their use of the platform, including the
              preparation, sale, purchase, marketing, transportation, or consumption of homemade food
              products, complies with all applicable local laws, food safety regulations, licensing requirements,
              tax obligations, health codes, and consumer protection laws in their respective jurisdictions.
            </p>
          </section>

          <section
            id="michigan-law"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">2. Michigan Law</h4>
            <p className="size-16 fw-normal">
              To the extent permitted by applicable law, these Terms and any dispute arising out of or relating
              to the use of OwnFood shall be governed by and construed in accordance with the laws of the
              State of Michigan, United States, without regard to its conflict of law principles.
            </p>
            <p className="size-16 fw-normal">
              If OwnFood operates or provides services in jurisdictions outside the United States, local
              mandatory consumer protection, food safety, privacy, or commercial laws of those jurisdictions
              may additionally apply where required by law.
            </p>
          </section>

          <section
            id="local-international"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">3. Local or International Use</h4>
            <p className="size-16 fw-normal">
              Users accessing OwnFood from any State of USA or countries outside the United States
              acknowledge that they do so at their own initiative and are responsible for compliance with their
              local laws and regulations.
            </p>
            <p className="size-16 fw-normal">
              OwnFood makes no representation that the platform, services, or content are appropriate or
              legally permitted in every country or jurisdiction. Access to the platform may be restricted or
              prohibited in certain regions where homemade food sales or related activities are regulated or
              unlawful.
            </p>
          </section>

          <section
            id="jurisdiction-venue"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">4. Jurisdiction and Venue</h4>
            <p className="size-16 fw-normal">
              Any legal action, claim, dispute, or proceeding arising from or related to the use of OwnFood
              shall, unless otherwise required by mandatory local law, be subject to the exclusive jurisdiction
              of the state or federal courts located in the State of Michigan, United States.
            </p>
            <p className="size-16 fw-normal">
              Where local laws grant consumers the right to bring claims in their country, province, or state of
              residence, such rights shall remain unaffected.
            </p>
          </section>

          <section
            id="dispute-resolution"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">5. Dispute Resolution</h4>
            <p className="size-16 fw-normal">
              Before initiating formal legal proceedings, users agree to first attempt to resolve disputes
              informally by contacting OwnFood through its official support channels.
            </p>
            <p className="size-16 fw-normal">
              OwnFood reserves the right, where legally enforceable, to require disputes to be resolved
              through mediation, arbitration, or other alternative dispute resolution methods in accordance
              with applicable laws.
            </p>
          </section>

          <section
            id="severability"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">6. Severability</h4>
            <p className="size-16 fw-normal">
              If any provision of this Governing Law section is determined to be unlawful, invalid, or
              unenforceable under applicable law, the remaining provisions shall remain in full force and
              effect.
            </p>
          </section>

          <section
            id="language"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">7. Language</h4>
            <p className="size-16 fw-normal">
              If these Terms are translated into another language, the English version shall control in the
              event of any conflict or inconsistency, unless prohibited by local law.
            </p>
          </section>

          <section
            id="food-regulations"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">8. Compliance With Local Food Regulations</h4>
            <p className="size-16 fw-normal">Sellers and food providers using OwnFood are independently responsible for:</p>
            <ul className="ps-2 size-16 fw-normal">
              <ListItem>Obtaining any required permits, licenses, or certifications;</ListItem>
              <ListItem>
                Following applicable cottage food laws, food handling regulations, labeling requirements, and
                health standards;
              </ListItem>
              <ListItem>
                Ensuring the accuracy of ingredient, allergen, and nutritional information where required by law;
              </ListItem>
              <ListItem>Complying with tax, import/export, and e-commerce regulations applicable in their jurisdiction.</ListItem>
            </ul>

            <p className="size-16 fw-normal mt-4">
              In the United States, all 50 states allow some type of homemade food sales through what
              are called <strong>"Cottage Food Laws."</strong> These laws let people prepare certain foods in their home
              kitchen and sell them legally.
            </p>
            <p className="size-16 fw-normal">However, each state has different rules about:</p>
            <ul className="ps-2 size-16 fw-normal">
              <ListItem>What foods you can sell</ListItem>
              <ListItem>Where you can sell (home, farmers markets, online, etc.)</ListItem>
              <ListItem>Revenue limits</ListItem>
              <ListItem>Whether you need a license or food safety training</ListItem>
            </ul>

            <p className="size-16 fw-normal mt-4 fw-bold">
              In USA all 50 States allows Homemade Food Sales (Cottage Food Laws).
            </p>

            <h5 className="fw-bold mt-4">Foods Commonly Allowed to Sell From Home in USA</h5>
            <p className="size-16 fw-normal">Most states allow non-perishable foods, such as:</p>
            <ul className="ps-2 size-16 fw-normal">
              <ListItem>Cakes, cookies, breads</ListItem>
              <ListItem>Muffins and pastries</ListItem>
              <ListItem>Jams &amp; jellies</ListItem>
              <ListItem>Candy</ListItem>
              <ListItem>Dry spice mixes</ListItem>
              <ListItem>Granola</ListItem>
              <ListItem>Honey</ListItem>
              <ListItem>Pickles (sometimes)</ListItem>
            </ul>

            <h5 className="fw-bold mt-4">Usually NOT allowed without special permits in USA:</h5>
            <ul className="ps-2 size-16 fw-normal">
              <ListItem>Meat dishes</ListItem>
              <ListItem>Seafood</ListItem>
              <ListItem>Dairy-heavy foods</ListItem>
              <ListItem>Foods requiring refrigeration</ListItem>
            </ul>
          </section>

          <section
            id="disclaimer"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">OwnFood Platform Disclaimer &amp; Food Compliance Policy</h4>
            <p className="size-16 fw-normal">
              OwnFood does not manufacture, prepare, store, inspect, certify, or control any food products
              sold by independent sellers on the platform. Each seller is solely responsible for ensuring that
              all food items offered for sale comply with all applicable local, state, federal, and international
              laws, regulations, permits, licensing requirements, health codes, and food safety standards in
              the jurisdiction where the food is prepared, marketed, sold, or delivered.
            </p>
            <p className="size-16 fw-normal">
              OwnFood shall not be held liable or accountable for any illegal food sales, unauthorized food
              preparation, unlicensed food operations, prohibited food items, mislabeled products, food safety
              violations, allergic reactions, contamination, illness, damages, losses, or legal violations
              committed by sellers or buyers using the platform.
            </p>
            <p className="size-16 fw-normal">
              The sale, listing, promotion, distribution, or delivery of any alcoholic beverages, liquor, beer,
              wine, or any alcohol-related products is strictly prohibited on OwnFood.
            </p>
            <p className="size-16 fw-normal">
              All sellers are required to clearly and accurately disclose all ingredients, allergens, preparation
              details, and relevant food information in their listings. Buyers are solely responsible for
              reviewing ingredient information, allergy warnings, and product descriptions before placing any
              order. By purchasing through the platform, buyers acknowledge and accept full responsibility for
              verifying whether a food product is suitable for their dietary, medical, religious, or personal
              requirements.
            </p>
            <p className="size-16 fw-normal">
              OwnFood reserves the right to remove listings, suspend accounts, or take legal action against
              any user violating platform policies or applicable laws.
            </p>
          </section>

          <section
            id="contact"
            style={{ scrollMarginTop: "9rem" }}
            className="mb-5"
          >
            <h4 className="fw-bold">Contact Information</h4>
            <p className="size-16 fw-normal">
              If you have any questions regarding this Privacy Policy, Governing Law section, or international
              compliance matters, you may contact:
            </p>
            <p className="size-16 fw-normal mb-1"><strong>OwnFood Support Team</strong></p>
            <p className="mb-0 size-16 fw-normal">
              Email:{" "}
              <a href="mailto:support@ownfood.com" className="text-decoration-none">
                support@ownfood.com
              </a>{" "}
              &nbsp;|&nbsp;{" "}
              <a href="mailto:info@ownfood.com" className="text-decoration-none">
                info@ownfood.com
              </a>
            </p>
            <p className="size-16 fw-normal">
              Website:{" "}
              <a href="https://www.ownfood.com" className="text-decoration-none">
                www.ownfood.com
              </a>
            </p>
          </section>
        </div>

        {/* RIGHT SIDE: TABLE OF CONTENTS (STICKY) */}
        <div className="col-lg-4 col-xl-3 d-none d-lg-block">
          <div className="sticky-top z-0" style={{ top: "9rem", zIndex: 1 }}>
            <h5 className="fw-bold mb-3 mt-1">Table of Contents</h5>
            <div className="border-start border-2">
              {sections.map((section, index) => (
                <a
                  key={section.id}
                  href={`#${section.id}`}
                  className="d-block py-2 px-3 text-decoration-none text-muted border-bottom"
                  style={{ fontSize: "1rem", transition: "0.2s" }}
                  onMouseOver={(e) => (e.target.style.color = "#007bff")}
                  onMouseOut={(e) => (e.target.style.color = "#6c757d")}
                >
                  {section.title}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
